// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"746c7e42","453":"64aababc","531":"d5f4dee7","672":"4037af7c","698":"37f14f62","720":"4ef0a902","749":"f278ac1c","759":"3da667f1","797":"d7f1e728","957":"25483591"}[chunkId] + ".chunk.js";
};